<template>
  <div class="">
    <router-link
      :to="getProgramApplyRoute()"
      class="my-4 text-yellow-900 hover:text-yellow-200 block is-fullwidth bg-yellow-500 border border-yellow-400 rounded hover:no-underline py-3 px-2"
    >
      Apply to {{ program.name }}
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    organization: {
      type: Object,
      required: true,
    },
    program: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const getProgramApplyRoute = () => {
      return {
        name: 'organizationPageRegisterStartup',
        params: {
          orgId: props.organization.id,
          programId: props.program.id,
        },
      }
    }
    return {
      getProgramApplyRoute,
    }
  },
}
</script>
